import { createSlice } from "@reduxjs/toolkit";
import WishlistService from "./services/wishlistService";

let initialState: any;
WishlistService.getWishlist().then((d) => {
  localStorage.setItem("likes", JSON.stringify(d));
});
try {
  initialState = localStorage.getItem("likes")
    ? JSON.parse(localStorage.getItem("likes")!)
    : [];
} catch {
  initialState = [];
}

export const likeSlice = createSlice({
  name: "likes",
  initialState,

  reducers: {
    setLike: (state, action) => {
      let data = localStorage.getItem("likes")
        ? JSON.parse(localStorage.getItem("likes")!)
        : [];
      if (!data.includes(action.payload)) data.push(action.payload);
      localStorage.setItem("likes", JSON.stringify(data));
      return data;
    },
    pull: (state, action) => {
      state = action.payload;
    },
    getLike: (state, action) => {
      return action.payload;
    },
    removeLike: (state, action) => {
      let data = localStorage.getItem("likes")
        ? JSON.parse(localStorage.getItem("likes")!)
        : [];
      const likes = data.filter(function (item: any) {
        return item !== action.payload;
      });
      localStorage.setItem("likes", JSON.stringify(likes));
      return likes;
    },
  },
});

export const { setLike, getLike, removeLike } = likeSlice.actions;

// export const selectItems = (state:any) => state;

export default likeSlice.reducer;
